import React from "react"

import InlineNotice from "src/components/InlineNotice"

const ErrorState = () => (
  <InlineNotice variant="error">Couldn&apos;t load activity.</InlineNotice>
)

export default ErrorState
